var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-wrap"},[_c('pageTitle',{attrs:{"pageTitle":"快问快答"}}),_c('div',[_c('exam-list',{attrs:{"scene":"material"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }